import React, { Component } from 'react';
import { Form, Button, Icon, Table, Checkbox } from 'semantic-ui-react';
import Select from "antd/es/select";
import "antd/es/select/style/index.css";
import './styles.scss';
import {
    Link
} from "react-router-dom";
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';
import _ from 'lodash';
import { DateInput } from "semantic-ui-calendar-react";
import { employee } from '../../core/services/employee.service';
import moment from 'moment';
import functionCommon from '../../core/common/function';
class EmployeeForm extends Component {
    constructor() {
        super();
        this.state = {
            errInputMsg: {}
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            errInputMsg: nextProps.isError
        });
    }

    addOrRemove = (value, idx) => {
        if (value === 'minus') {
            this.state.errInputMsg['positionCode-' + idx] = "";
            this.state.errInputMsg['departmentName-' + idx] = "";
        }
        return this.props.handleAddOrRemove({ value: value, idx: idx });
    }

    handleChangeAutoComplete = (name, value) => {
        this.props.changeAutoComplete({_name: name, _value: value});
    }

    handleChangeDateCheckBox = (event, { name, value }) => {
        this.props.changeDateCheckboxEmployee(value, name);
    };

    handleChangeCheckbox = () => {
        this.props.changeDateCheckboxEmployee(Number(this.props.employeeData.isOMSite)? 0 : 1, "isOMSite");
    };

    handleKeyDown = (event) => {
        if (event.keyCode === 8 || event.keyCode === 46) {
            event.preventDefault();
        }
    };

    render() {
        const { employeeData, dataPosition, dataDepartment, changeEmpoyee, t, isDisableOfficialDate } = this.props;
        const _dataPosition = _.map(dataPosition, (state, index) => ({
            key: "positionCode-" + index + 1,
            text: state['positionName'],
            value: state['id'],
        }));
        _dataPosition.unshift({
            key: "positionCode-0",
            text: 'All',
            value: '',
        });
        const { Option } = Select;
        const roleOptions = [
            { value: '0', text: 'Staff' },
            { value: '1', text: 'HR' },
            { value: '2', text: 'Admin' },
            { value: '3', text: 'Director' }
        ]
        const levelOptions = [
            { value: '0', text: 'Staff' },
            { value: '1', text: 'Manager' },
            { value: '2', text: 'Director' },
            { value: '3', text: 'Supervisor' },
            { value: '4', text: 'Team Leader' }
        ]
        const billableOptions = [
            { value: 1, text: t('labels.yes') },
            { value: 0, text: t('labels.no') }
        ]
        return (
            <div className="employee-form">
                <Form>
                    <Form.Group inline className="form-required">
                        <label>{t('labels.employeeCode')}</label>
                        <Form.Input
                            name="employeeCode"
                            value={employeeData.employeeCode}
                            onChange={changeEmpoyee.bind(this)}
                            maxLength="12" />
                    </Form.Group>
                    {
                    (this.state.errInputMsg['employeeCode'])
                    ? <div className="error-message form-list-message">{t(this.state.errInputMsg['employeeCode'])}</div>
                    : ''
                    }
                    <Form.Group inline>
                        <label>{t('labels.nickName')}</label>
                        <Form.Input
                            name="nickName"
                            value={employeeData.nickName}
                            onChange={changeEmpoyee.bind(this)}
                            maxLength="50" />
                    </Form.Group>
                    <Form.Group inline className="form-required">
                        <label>{t('labels.firstName')}</label>
                        <Form.Input
                            name="firstName"
                            value={employeeData.firstName}
                            onChange={changeEmpoyee.bind(this)}
                            maxLength="50" />
                    </Form.Group>
                    {
                    (this.state.errInputMsg['firstName'])
                    ? <div className="error-message form-list-message">{t(this.state.errInputMsg['firstName'])}</div>
                    : ''
                    }
                    <Form.Group inline>
                        <label>{t('labels.lastName')}</label>
                        <Form.Input
                            name="lastName"
                            value={employeeData.lastName}
                            onChange={changeEmpoyee.bind(this)}
                            maxLength="50" />
                    </Form.Group>
                    <Form.Group inline>
                        <label>{t('labels.email')}</label>
                        <Form.Input
                            name="email"
                            value={employeeData.email}
                            onChange={changeEmpoyee.bind(this)}
                            maxLength="255" />
                    </Form.Group>
                    {
                    (this.state.errInputMsg['email'])
                    ? <div className="error-message form-list-message">{t(this.state.errInputMsg['email'])}</div>
                    : ''
                    }
                    <Form.Group inline className="form-required">
                        <label>{t('labels.role')}</label>
                        <select name="role"
                            value={employeeData.role}
                            onChange={changeEmpoyee.bind(this)}>
                            <option value="">All</option>
                            {roleOptions.map((option, index) => {
                                return (
                                    <option value={option.value} key={index}>{option.text}</option>
                                )
                            }
                            )}
                        </select>
                    </Form.Group>
                    {
                    (this.state.errInputMsg['role'])
                    ? <div className="error-message form-list-message">{t(this.state.errInputMsg['role'])}</div>
                    : ''
                    }
                    <Form.Group inline className="form-required">
                        <label>{t('labels.billable')}</label>
                        <select name="billable"
                            value={employeeData.billable}
                            onChange={changeEmpoyee.bind(this)}>
                            <option value="">All</option>
                            {billableOptions.map((option, index) => {
                                return (
                                    <option value={option.value} key={index}>{option.text}</option>
                                )
                            }
                            )}
                        </select>
                    </Form.Group>
                    {
                    (this.state.errInputMsg['billable'])
                    ? <div className="error-message form-list-message">{t(this.state.errInputMsg['billable'])}</div>
                    : ''
                    }
                    <Form.Group inline className="form-required">
                        <label>{t('labels.level')}</label>
                        <select name="level"
                            value={employeeData.level}
                            onChange={changeEmpoyee.bind(this)}>
                            <option value="">All</option>
                            {levelOptions.map((option, index) => {
                                return (
                                    <option value={option.value} key={index}>{option.text}</option>
                                )
                            }
                            )}
                        </select>
                    </Form.Group>
                    {
                    (this.state.errInputMsg['level'])
                    ? <div className="error-message form-list-message">{t(this.state.errInputMsg['level'])}</div>
                    : ''
                    }
                    <Form.Group inline className="form-required form-status">
                        <label>{t('labels.status')}</label>
                        <div>
                            <Form.Field>
                                <input id="radio-working" type="radio" name="status"
                                    value={0}
                                    checked={employeeData.status == 0}
                                    onChange={changeEmpoyee.bind(this)} />
                                <label htmlFor="radio-working">{t('labels.working')}</label>
                            </Form.Field>
                            <Form.Field>
                                <input id="radio-non-working" type="radio" name="status"
                                    value={1}
                                    checked={employeeData.status == 1}
                                    onChange={changeEmpoyee.bind(this)} />
                                <label htmlFor="radio-non-working">{t('labels.nonWorking')}</label>
                            </Form.Field>
                        </div>
                    </Form.Group>
                    <Form.Group inline className="form-required">
                        <label>{t("labels.startingDate")}</label>
                        <DateInput
                            className="form-date leave-date-input-restrict"
                            name="startingDate"
                            placeholder="DD-MM-YYYY"
                            iconPosition="right"
                            animation="none"
                            dateFormat="DD-MM-YYYY"
                            value={employeeData.startingDate}
                            onChange={this.handleChangeDateCheckBox}
                            closeOnMouseLeave={false}
                            localization={localStorage.getItem("i18nextLng") === "en" ? "en" : "vi"}
                            hideMobileKeyboard={true}
                            autoComplete="off"
                            maxLength="0"
                            closable={true}
                            onKeyDown={functionCommon.onKeyDownDateInput}
                            onMouseEnter={functionCommon.onMouseEnterDateInput}
                            onMouseLeave={functionCommon.onMouseLeaveDateInput}
                        />
                    </Form.Group>
                    {
                    this.state.errInputMsg["startingDate"] ? (
                        <div className="error-message form-list-message">
                            {t(this.state.errInputMsg["startingDate"], { field: t("labels.startingDate") })}
                        </div>
                    ) : (
                        ""
                    )}
                    <Form.Group inline>
                        <label>{t("labels.officialDate")}</label>
                        <DateInput
                            className="form-date leave-date-input-restrict"
                            name="officialDate"
                            placeholder="DD-MM-YYYY"
                            iconPosition="right"
                            animation="none"
                            dateFormat="DD-MM-YYYY"
                            value={employeeData.officialDate}
                            onChange={this.handleChangeDateCheckBox}
                            closeOnMouseLeave={false}
                            localization={localStorage.getItem("i18nextLng") === "en" ? "en" : "vi"}
                            hideMobileKeyboard={true}
                            autoComplete="off"
                            maxLength="0"
                            disabled={isDisableOfficialDate}
                            closable={true}
                            onKeyDown={functionCommon.onKeyDownDateInput}
                            onMouseEnter={functionCommon.onMouseEnterDateInput}
                            onMouseLeave={functionCommon.onMouseLeaveDateInput}
                        />
                    </Form.Group>
                    {
                    this.state.errInputMsg["officialDate"] ? (
                        <div className="error-message form-list-message">
                            {t(this.state.errInputMsg["officialDate"], { field: t("labels.officialDate") })}
                        </div>
                    ) : (
                        ""
                    )}
                    <Form.Group inline>
                        <label>{t("labels.resignDate")}</label>
                        <DateInput
                            className="form-date leave-date-input-restrict"
                            name="resignDate"
                            placeholder="DD-MM-YYYY"
                            iconPosition="right"
                            animation="none"
                            dateFormat="DD-MM-YYYY"
                            value={employeeData.resignDate}
                            onChange={this.handleChangeDateCheckBox}
                            closeOnMouseLeave={false}
                            localization={localStorage.getItem("i18nextLng") === "en" ? "en" : "vi"}
                            hideMobileKeyboard={true}
                            autoComplete="off"
                            maxLength="0"
                            closable={true}
                            minDate={moment().format("DD-MM-YYYY")}
                            onKeyDown={functionCommon.onKeyDownDateInput}
                            onMouseEnter={functionCommon.onMouseEnterDateInput}
                            onMouseLeave={functionCommon.onMouseLeaveDateInput}
                        />
                    </Form.Group>
                    {this.state.errInputMsg["resignDateWithStarting"] && (
                        <div className="error-message form-list-message">
                            {t(this.state.errInputMsg["resignDateWithStarting"])}
                        </div>
                    )}
                    {this.state.errInputMsg["resignDateWithOfficial"] && (
                        <div className="error-message form-list-message">
                            {t(this.state.errInputMsg["resignDateWithOfficial"])}
                        </div>
                    )}
                    <Form.Group inline className="om-site">
                        <label />
                        <Checkbox
                            label={t("labels.omSite")}
                            onClick={this.handleChangeCheckbox}
                            checked={Number(employeeData.isOMSite)}
                        />
                    </Form.Group>
                </Form>
                <Form id="posDepart" className="position-deparment">
                    <Table unstackable>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell></Table.Cell>
                                <Table.Cell className="form-required">
                                    <label>{t('labels.position')}</label>
                                    <label className="new-label">
                                        <Link to="/position">{t('labels.newPosition')}</Link>
                                    </label>
                                </Table.Cell>
                                <Table.Cell className="form-required">
                                    <label>{t('labels.department')}</label>
                                    <label className="new-label">
                                        <Link to="/department">{t('labels.newDepartment')}</Link>
                                    </label>
                                </Table.Cell>
                                <Table.Cell></Table.Cell>
                            </Table.Row>
                            {employeeData.employeePosition.map((emPos, i) =>
                                <Table.Row key={i}>
                                    <Table.Cell>
                                        <input id="radio-ismain" type="radio" name={'isMain-' + i}
                                            value={1}
                                            checked={emPos.isMain == '1'}
                                            onChange={changeEmpoyee.bind(this)} />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Select
                                            name={'positionCode-' + i}
                                            onChange={(input, option) => this.handleChangeAutoComplete('positionCode-' + i, option.props.value)}
                                            style={{ width: 196 }}
                                            showSearch
                                            filterOption={(input, option) =>
                                                option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            value={parseInt(emPos.positionId) || ''}>
                                            {(_dataPosition)
                                                ? _dataPosition.map((item, index) => {
                                                    return (
                                                        <Option value={item.value} key={item.key} label={item.text}>{item.text}</Option>
                                                    )
                                                })
                                                : ''
                                            }
                                        </Select>
                                        {
                                        (this.state.errInputMsg['positionCode-' + i])
                                        ? <div className="error-message no-margin">{t(this.state.errInputMsg['positionCode-' + i])}</div>
                                        : ''
                                        }
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Select
                                            name={'departmentName-' + i}
                                            onChange={(input, option) => this.handleChangeAutoComplete('departmentName-' + i, option.props.value)}
                                            style={{ width: 196 }}
                                            showSearch
                                            filterOption={(input, option) =>
                                                option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            value={parseInt(emPos.departmentId) || ''}>
                                            <Option value="" key={0} label="All">All</Option>
                                            {(dataDepartment)
                                                ? dataDepartment.map((item, index) => {
                                                    return (
                                                        <Option value={item.id} key={item.departmentCode} label={item.departmentName}>{item.departmentName}</Option>
                                                    )
                                                })
                                                : ''
                                            }
                                        </Select>
                                        {
                                        (this.state.errInputMsg['departmentName-' + i])
                                        ? <div className="error-message no-margin">{t(this.state.errInputMsg['departmentName-' + i])}</div>
                                        : ''
                                        }
                                    </Table.Cell>
                                    <Table.Cell>
                                        {(i === 0)
                                            ? <Button size="tiny" icon onClick={(e) => this.addOrRemove('add', i)}><Icon name='add' /></Button>
                                            : <Button size="tiny" icon onClick={(e) => this.addOrRemove('minus', i)}><Icon name='minus' /></Button>
                                        }
                                    </Table.Cell>
                                </Table.Row>
                            )}
                        </Table.Body>
                    </Table>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(EmployeeForm);
